export const buildMailtoHref = (emails: string[]): string | undefined => {
  if (emails.length === 0) {
    return undefined;
  }
  return `mailto:${emails.join(',')}`;
};
